// extracted by mini-css-extract-plugin
module.exports = {"root":"Submenu_root__S3hMS","item":"Submenu_item__YemWM","active":"Submenu_active__tUhuO","open":"Submenu_open__q2wda","list":"Submenu_list__zW_yc"};